import gql from 'graphql-tag';

export const invitationsQuery = gql`
  query InvitationsQuery {
    invitations {
      id
      name
      email
      inviteCode
      acceptedOn
      invitedBy {
        email
      }
    }
  }
`;

export const invitationQuery = gql`
  query InvitationQuery($inviteCode: String!) {
    findInvitation(inviteCode: $inviteCode) {
      id
      inviteCode
      email
      name
    }
  }
`;

export const invitationsCreateMutation = gql`
  mutation InvitationsCreateMutation($input: CreateInvitationInput!) {
    createInvitation(input: $input) {
      invitation {
        email
        inviteCode
      }
      errors {
        path
        message
      }
    }
  }
`;
